module.exports = __webpack_public_path__ + "static/media/for-startups-access.ed85c424.jpg";